export function getUserInitials(username: string) {
    var matches = username.match(/\b(\w)/g);
    return matches ? matches.join('').toUpperCase() : 'JD';
}